<template>
  <div class="mobile-button-container">
    <v-flex class="mb-16 mobile-button hide">
      <main-button
        depressed
        :text="adminText('workflowsAll.create_email_cf6523e', 'Create email')"
        @click="goTo(routes.organizer.createEmail, { eventId: eventId })"
      />
    </v-flex>
    <v-layout column>
      <div class="page-header">
        <v-flex class="title-screen" xs12>
          <span>{{ adminText('workflowsAll.e_mails_to_invitees_a560441', 'E-mails to invitees') }}</span>
        </v-flex>
        <v-flex class="mb-16 desktop-button">
          <main-button
            depressed
            @click="goTo(routes.organizer.createEmailInvitation, { eventId: eventId })"
          >
            <div class="plus-sign">+</div>
            {{ adminText('workflowsAll.create_email_cf6523e', 'Create email') }}
          </main-button>
        </v-flex>
      </div>
      <v-data-table
        v-model="tableValue"
        :headers="workflowUi(headers)"
        :items="workflowUi(items)"
        :rows-per-page-items="rowsPerPageItems"
        :rows-per-page-text="workflowLabel(isDesktop ? adminText('workflowsAll.rows_per_page_79df325', 'Rows per page:') : '')"
        item-key="id"
        disable-initial-sort
        style="border: 1px solid #f5f5f5 !important"
        class="table-container"
      >
        <template slot="items" slot-scope="props">
          <tr
            style="
              position: relative;
              z-index: 4;
              cursor: pointer;
              border: 1px solid #f5f5f5 !important;
            "
            @click="openEmailDetails(props.item.id)"
          >
            <td>
              <v-flex justify-center align-center>
                <v-switch
                  v-if="props.item.type == 'Automated'"
                  :input-value="props.item.status"
                  color="#ff4c00"
                  style="position: relative; z-index: 1"
                  @click.prevent="e => changeButton(e, props.item)"
                />
                <span v-else class="sent-style">{{ adminText('workflowsAll.sent_35f49dc', 'Sent') }}</span>
              </v-flex>
            </td>
            <td>
              <div
                :class="props.item.type == 'Custom' ? 'custom-type-style' : 'automated-type-style'"
              >
                <span>{{ workflowLabel(props.item.type) }}</span>
              </div>
            </td>
            <td>
              <span v-if="props.item.type == 'Automated'">{{ workflowLabel(props.item.sent) }}</span>
              <span v-else>{{ workflowDate(props.item.updatedAt, 'LL H:mm') }}</span>
            </td>
            <td>{{ workflowLabel(props.item.subject) }}</td>
            <td>{{ workflowLabel(props.item.emailRecipient.recipientType) }}</td>
            <td>
              <v-icon
                v-show="props.item.type == 'Custom'"
                :key="props.item.id"
                small
                @click.prevent="e => startDelete(props.item, e)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data"> {{ adminText('workflowsAll.create_your_first_referral_3d73968', 'Create your first referral') }} </template>
      </v-data-table>
    </v-layout>
    <delete-dialog
      :content="workflowLabel((adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_emai_23aa06b', 'Are you sure you want to delete selected email? This operation cannot be undone.')))"
      :on-delete="deleteEmail"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.delete_email_12b2a4e', 'Delete email')"
    />
    <success-snackbar
      :open="wasEmailSent"
      :title="adminText('workflowsAll.success_42a8f65', 'Success')"
      :message="adminText('workflowsAll.your_email_was_sent_successfully_d225ae7', 'Your email was sent successfully!')"
    />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import SuccessSnackbar from '../shared/snackbars/success-snackbar'
import { formatDate } from '../../utils'
import { GET_EMAILS, DELETE_EMAIL, UPDATE_EMAIL } from '../../graphql/email.graphql'

export default {
  mixins: [WorkflowDisplay],
  name: 'email-to-invitee',
  components: {
    DeleteDialog,
    SuccessSnackbar,
  },
  props: {
    eventId: String,
    wasEmailSent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      attendeeFields: [],
      eventAttendeeFields: {},
      showDeleteDialog: false,
      tableValue: [],
      deleteId: undefined,
      isDesktop: false,
      headers: [
        {
          text: 'workflowsAll.status_bae7d5b',
          align: 'left',
          sortable: true,
          value: 'status',
        },
        {
          text: 'workflowsAll.type_3deb745',
          align: 'left',
          sortable: true,
          value: 'type',
        },
        {
          text: 'workflowsAll.sent_35f49dc',
          align: 'left',
          sortable: true,
          value: 'sent',
        },
        {
          text: 'workflowsAll.subject_8d183db',
          align: 'left',
          sortable: true,
          value: 'subject',
        },
        {
          text: 'workflowsAll.recipients_78cbf8e',
          align: 'left',
          sortable: true,
          value: 'recipients',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: null,
        },
      ],
      items: [],
      rowsPerPageItems: [5, 10, 25, 100],
    }
  },
  apollo: {
    getEmails: {
      query: GET_EMAILS,
      variables() {
        return {
          eventId: this.eventId,
          curatedInvitee: true,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const { getEmails } = data
          this.items = getEmails
            .map(email => {
              return {
                ...email,
                updatedAt: email.updatedAt,
              }
            })
            .sort((a, b) => {
              return a.id - b.id
            })
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    openEmailDetails(id) {
      this.goTo(this.routes.organizer.emailDetails, { eventId: this.eventId, emailId: id })
    },
    async changeButton(ev, item) {
      ev.stopPropagation()
      await this.$apollo.mutate({
        mutation: UPDATE_EMAIL,
        variables: {
          emailId: item.id,
          email: {
            status: !item.status,
          },
        },
        refetchQueries: ['GetEmails'],
      })
    },
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
    startDelete(email, ev) {
      ev.stopPropagation()
      this.showDeleteDialog = true
      this.deleteId = email.id
    },
    async deleteEmail() {
      await this.$apollo.mutate({
        mutation: DELETE_EMAIL,
        variables: { emailId: this.deleteId },
        refetchQueries: ['GetEmails'],
      })
      this.showDeleteDialog = false
      this.deleteId = undefined
    },
  },
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-end;
}
.plus-sign {
  font-size: 2.25rem;
  font-weight: 100;
  margin-right: 0.625rem;
}
.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
}
</style>
